// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"22b595de","453":"f216a4ac","481":"fca94e45","550":"298b2410","721":"2d193e9b"}[chunkId] + ".chunk.js";
};